module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [(_vm.isWechat) ? _c('div', {
    staticClass: "t1"
  }, [_vm._v("绑定手机")]) : _c('div', {
    staticClass: "t1"
  }, [_vm._v("登录/注册")]), _vm._v(" "), _c('div', {
    staticClass: "t2"
  }, [_vm._v("绑定手机享受更多服务")]), _vm._v(" "), (_vm.tip) ? _c('div', {
    staticClass: "t0"
  }, [_vm._v("\n        当前集数已播放完毕，邀请您登录/注册福音TV会员\n        "), _c('br'), _vm._v("避免失联，随时在线\n    ")]) : _c('div', {
    staticClass: "t0"
  }, [_vm._v("\n        邀请您登录/注册福音影视网（福音TV）会员\n        "), _c('br'), _vm._v("避免失联，随时在线\n    ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.areaVisible = true
      }
    }
  }, [_vm._v("+" + _vm._s(_vm.area))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "placeholder": "请输入您的手机号",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.phone) ? _c('a', {
    staticClass: "icon icon-close",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.phone = ''
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input"
  }, [_c('span', [_vm._v("验证码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "placeholder": "请输入获取的验证码",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.cold > 0) ? _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v(_vm._s(_vm.cold) + "s")]) : _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onSendCode
    }
  }, [_vm._v("发送验证码")])])]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [(_vm.isWechat) ? _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("确认绑定")]) : _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("登录/注册")])]), _vm._v(" "), (_vm.ignore) ? _c('div', {
    staticClass: "btn"
  }, [_c('a', {
    staticClass: "off",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("下次再说")])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.areaVisible) ? _c('div', {
    ref: "areas",
    staticClass: "areas"
  }, [_vm._l((_vm.areas), function(j, i) {
    return _c('div', {
      key: i
    }, [_c('div', {
      staticClass: "areas-title"
    }, [_vm._v(_vm._s(i))]), _vm._v(" "), _vm._l((_vm.areas[i]), function(item, k) {
      return _c('a', {
        key: k,
        staticClass: "areas-item",
        attrs: {
          "href": "javascript:;"
        },
        on: {
          "click": function($event) {
            return _vm.onChooseArea(item)
          }
        }
      }, [_c('span', [_vm._v(_vm._s(item.n))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.c))])])
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "contents"
  }, _vm._l((_vm.areas), function(j, i) {
    return _c('a', {
      key: i,
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onScrollTo(i)
        }
      }
    }, [_vm._v(_vm._s(i))])
  }), 0)], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "t5"
  }, [_vm._v("\n        手机号将作为您的会员账户，可以在福音TV app\n        "), _c('br'), _vm._v("上直接登录，笔记、收藏云端在线，多端同步。\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download"
  }, [_c('a', {
    attrs: {
      "href": "http://www.fytvapp.com"
    }
  }, [_vm._v("\n            点击下载福音TV App\n            "), _c('br'), _vm._v("(暂不绑定)\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62c75ffc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/phone/index.vue
// module id = 331
// module chunks = 0